var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header",class:`page-header--${_vm.view}`},[_c('h1',{staticClass:"page-header__title"},[_vm._t("default")],2),_vm._t("extra")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }